import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Solvr</h3>
            <p>Building successful businesses through modern web solutions.</p>
          </div>
          
          <div className="footer-section">
            <h4>Locations</h4>
            <ul>
              <li>Chicago, IL</li>
              <li>Durham, NC</li>
              <li>Coralville, IA</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <p>
              <a href="mailto:solvrcontact@gmail.com">solvrcontact@gmail.com</a>
            </p>
            <p>
              <a href="tel:815-999-5245">(815) 999-5245</a>
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Solvr. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 